import { useState } from 'react';

import { useAuth } from './AuthContext.jsx';
import { Button, Field, Input, PasswordInput } from '../../components/ui.jsx';

export default function LoginPage() {
  const { signIn } = useAuth();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const signInWith = async (credentials) => {
    setError(null);
    setIsSubmitting(true);

    try {
      await signIn(credentials);
    } catch (signInError) {
      // The API returns the same message for a wrong password and an unknown
      // account, so nothing here can be used to enumerate administrators.
      setError(signInError.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  const submit = (event) => {
    event.preventDefault();
    return signInWith({ email, password });
  };

  return (
    <main className="login">
      <form className="login__card" onSubmit={submit}>
        <div className="login__brand">
          <div className="login__mark">S</div>
          <div>
            <h2>Grihvaas</h2>
            <span className="muted" style={{ fontSize: 13 }}>
              Administration
            </span>
          </div>
        </div>

        <Field label="Email" id="email">
          <Input
            id="email"
            type="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            autoComplete="username"
            required
            autoFocus
          />
        </Field>

        <Field label="Password" id="password" error={error}>
          <PasswordInput
            id="password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            autoComplete="current-password"
            required
            error={Boolean(error)}
          />
        </Field>

        <Button type="submit" variant="primary" size="lg" block loading={isSubmitting}>
          Sign in
        </Button>

        <p className="login__note">
          For the Grihvaas super-admin only. This account is separate from the apps, and every
          action here is audited.
        </p>
      </form>
    </main>
  );
}
